import React from 'react';
import { componentTypes } from '@white-nl/instantsearch-components';
import Xmark from '../../ui/icons/classic/solid/Xmark';
import TrashAlt from '../../ui/icons/classic/regular/TrashAlt';

export default function CurrentRefinements(
  {
    currentRefinements,
    currentRefinementsSettings,
    clearRefinements,
  }: componentTypes.CurrentRefinementsProps,
) {
  const { items, refine: refineCurrentRefinements } = currentRefinements;
  const { excludedAttributes, translations } = currentRefinementsSettings;
  const { refine: refineClearRefinements } = clearRefinements;

  const activeFilters = items
    .filter((item) => !excludedAttributes?.includes(item.attribute))
    .flatMap((item) => item.refinements.map((nested) => nested));

  if (activeFilters.length === 0) {
    return null;
  }

  // @ts-ignore
  function getLabel(filter) {
    if (filter.attribute === 'highlights') {
      const onSale = translations?.onSale ?? 'On Sale';
      const newProduct = translations?.newProduct ?? 'New';
      return filter.label === 'sale'
        ? onSale
        : newProduct;
    }
    if (filter.attribute === 'insoleRemovable') {
      const irYes = translations?.insoleRemovableYes ?? 'Insole Removable: Yes';
      const irNo = translations?.insoleRemovableNo ?? 'Insole Removable: No';
      return filter.label === '1'
        ? irYes
        : irNo;
    }
    if (filter.attribute === 'salePrice') {
      return `${filter.label.replace(' ', ' €')},-`;
    }
    return filter.label;
  }

  return (
    <>
      <div className="flex flex-wrap gap-2">
        {activeFilters.map((filter) => (
          <button
            key={`${filter.attribute}-${filter.value}`}
            className="cursor-pointer px-4 py-2 bg-light outline outline-1 outline-offset-[-1px] outline-dark/10 inline-flex justify-start items-center gap-2.5 text-sm font-normal text-dark leading-4"
            type="button"
            onClick={() => refineCurrentRefinements(filter)}
          >
            {getLabel(filter)}
            <Xmark iconClass="h-3.5 w-auto fill-current" />
          </button>
        ))}
      </div>
      <button
        className="cursor-pointer px-4 py-2 bg-light inline-flex justify-start items-center gap-2.5 text-sm font-normal text-dark leading-4 hover:text-accent"
        type="button"
        onClick={refineClearRefinements}
      >
        <TrashAlt iconClass="h-3.5 w-auto fill-current" />
        {translations?.clearAll ?? 'Clear All'}
      </button>
    </>
  );
}
